// 首页tab枚举
export enum CouponMallTabEnum {
  /** 全部 */
  ALL = '0',
}

// 权益类型枚举
export enum EquityTypeEnum {
  /** 优惠券 */
  COUPON = 1,
  /** 卡权益 */
  EQUITY_CARD = 17,
  /** 电池套餐 */
  BATTERY_PACKAGE = 31,
}
